var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"full-width-container",attrs:{"fluid":""}},[_c('transition',{attrs:{"appear":"","name":"custom","appear-active-class":"animated zoomIn","duration":2000}},[_c('div',{staticClass:"pa-2",class:'full-height'},[_c('SinistersList')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }